<div class="background-web">
    <div class="container-web">
        <div class="title">
            <div style="padding-left: 30px; padding-right: 30px; ">Not Found</div>
        </div>
        <div class="custom-container-web" style=" display: block;">
            <div style="padding-left: 0px;">The requested page could not be found.</div>
        </div>
    </div>
</div>

